import styled from 'styled-components'

export const Container = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const Month = styled.div`
  font-size: 4.5vw;
  align-self: stretch;
  font-weight: 600;
  padding: 0 1rem;
  ${({ theme: { colors } }) => `
    color: ${colors('background')};
    background: ${colors('link')};
  `}
`

export const Day = styled.div`
  font-size: 12vw;
  font-weight: 600;
  margin: 2vw 0;
`

export const Name = styled.div`
  font-size: 1.5vw;
  font-style: oblique;
  padding: 0 1rem;
  align-self: stretch;
  ${({ theme: { colors } }) => `
    color: ${colors('link')};
  `}
`

export const Empty = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5vw;
  font-style: oblique;
  ${({ theme: { colors } }) => `
    color: ${colors('neutral')};
  `}
`
